import './modules/resize-end.js'
import './modules/viewport-units.js'
import './modules/focus-visible-fallback.js'

import './alpine/init.js'

let resolveInitialized
let initialized = new Promise(resolve => (resolveInitialized = resolve))
Alpine.store('initialized', initialized)

let init = () => {
  Alpine.start()
  document.body.classList.remove('not-initialized')
  resolveInitialized()

  // https://github.com/GoogleChromeLabs/quicklink
  // Ignore when logged in as links with side effects could be inadvertently triggered
  if (!document.getElementById('wpadminbar')) {
    import('quicklink').then(({ listen }) => listen())
  }
}

// Await the 'wpce:after-element-scripts' event to avoid starting Alpine before
// element-specific groundwork (e.g. element-specific Alpine plugins) is laid
document.addEventListener(
  'wpce:after-element-scripts',
  () => {
    // Initializing Alpine is quite a bit of CPU work.
    // If the browser supports it, we delay its initialization
    // until there are free CPU cycles, with a maximum of 3 seconds.
    if ('requestIdleCallback' in window) {
      requestIdleCallback(init, { timeout: 3000 })
    } else {
      init()
    }
  },
  { once: true },
)
